import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GetAllWorkSchdule, GetWorkTimeAccess } from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';

const WorkShift = ({ workShiftAccessTime, workShiftSchedule, workShiftsList, setWorkShiftsList, page, setPage, rowsPerPage, setRowsPerPage }) => {

    const dispatch = useDispatch();

    const [workShift, setWorkShift] = useState(null);
    const [element, setElement] = useState([]);
    const [orderBy, setOrderBy] = useState('id');
    const [isValidWorkShift, setIsValidWorkShift] = useState(true);
    const [emptyFields, setEmptyFields] = useState(false);

    let workShiftPagination = {
        order: true,
        page: page,
        size: rowsPerPage,
        sortBy: orderBy,
    };

    useEffect(() => {
        dispatch(GetAllWorkSchdule());
    }, []);

    useEffect(() => {
        setPage(0);
        setRowsPerPage(10);
    }, [workShift]);

    useEffect(() => {
        if (workShift?.id) {
            dispatch(GetWorkTimeAccess({ id: workShift.id, contractPagination: workShiftPagination }));
        } else {
            return null;
        }
    }, [page, rowsPerPage]);

    const handleSetListWorkShift = (element) => {
        if(element) {
            setWorkShiftsList([...workShiftsList, element])
        }else{
            setWorkShiftsList([...workShiftsList])
        }
        setWorkShift(null)
    };

    const handleWorkShift = (e) => {
        if(e?.target?.value){
            let id = e.target.value;
            let name = workShiftSchedule.find((item) => item?.id === e.target.value).name;
            setWorkShift({ id: id, name: name });
            dispatch(GetWorkTimeAccess({ id, contractPagination: workShiftPagination }));
        }
        setEmptyFields(false);
        setIsValidWorkShift(true);
    }

    const reset = () => {
        setIsValidWorkShift(true);
        setEmptyFields(false);
    }

    return {
        workShift, setWorkShift,
        element, setElement,
        orderBy, setOrderBy,
        workShiftAccessTime,
        handleSetListWorkShift: (e) => handleSetListWorkShift(e),
        handleWorkShift: (e) => handleWorkShift(e),
        isValidWorkShift,
        setIsValidWorkShift,
        emptyFields,
        setEmptyFields,
        reset
    }

}



export default WorkShift;
